import React, {
    useState,
    useCallback,
    useContext,
    useEffect,
    useMemo,
} from "react";
import _, { get } from "lodash";
import PropTypes from "prop-types"
import {  withViewModelService,ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

;

import { withRouter } from "react-router-dom";
import { useTranslator,IntlContext } from "@jutro/locale";
import { MetadataContent } from "@jutro/legacy/uiconfig";
import { ServiceRequestService } from "gw-capability-servicerequest";
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import {  ModalNextContext } from "@jutro/components";
import { LoaderExt } from 'gw-components-platform-react';
import moment from "moment";
import PayrollService from "cpmi-capability-payroll/services/PayrollService";
import useGoogleAnalytics from "account-management/src/hooks/useGoogleAnalytics";
import metadata from "./PayrollReviewCA.metadata.json5";
import messages from "./PayrollReviewCA.messages";
import styles from "./PayrollReviewCA.module.scss";
import { end } from "cheerio/lib/api/traversing";

function PayrollReviewCA(props) {
    
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const [state,setStateName]=useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [viewStartPage, setviewStartPage] = useState(true);
    const [trackGAPageView]=useGoogleAnalytics();
    const [draftData,setDraftData]=useState({})
    const ModalNext = useContext(ModalNextContext);
    const intl = useContext(IntlContext);

    const { history } = props;
    const {onCallback,DraftDataFromReview} = props;
    const appValue=props?.location?.state?.appValue
    let  reviewData;
   
    let totalsArray =[];
    if(appValue==="CE")
    {
        reviewData = _.get(props, "location.state.data");    
    }
    else{
        reviewData = _.get(props, "data");
       
       
    }

    useEffect(() => {
        trackGAPageView("/payroll-reporting/reviewCA","Payroll Review")
    },[])
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const individualData=reviewData?.policyPremium!==undefined?reviewData?.policyPremium?.individualCosts:[]
    
    const handleSubmit = useCallback(() => {
        setLoadingState(true)
        ModalNext.showConfirm({
            title: messages.submitTitleCA,
            message: appValue==="PE"?messages.PEsubmitMessageCA:messages.submitMessageCA,
            status: "info",
            icon: "mi-error-outline",
            confirmButtonText: "Submit Report",
            cancelButtonText: "Edit Report",
            closeButton:"false"
        }).then(async (results) => {
            if (results === "confirm") {
                if (appValue === "PE") {
                    await PayrollService.PEsubmitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({pathname:props.location.peMainPayrollPath,state:"submitted",policyNumber:reviewData.policyNumber})
                } else {
                    await PayrollService.submitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({
                        pathname: `/payroll-reporting/list/success`,
                        state: {
                            appValue: "submitted",
                        },
                    });
                }
            } else if(appValue==='PE')
            {
                onCallback(true)
            }
            else{
                history.go(-1);
               
            }
        }, _.noop);
    }, [ModalNext, appValue, authHeader, history, onCallback, reviewData?.jobNumber, reviewData?.policyNumber]);

    const handleMakeChanges = useCallback(async() => {
       
        if(appValue==='PE')
        {
            const res = await PayrollService.PEchangeReportStatusToDraft(reviewData?.jobNumber,authHeader)

            setDraftData(res)
            setviewStartPage(true);
            onCallback(true)
            DraftDataFromReview(draftData)
        }
        else{
            await PayrollService.changeReportStatusToDraft(reviewData?.jobNumber,authHeader)
            history.go(-1);
        }
          
    }, [DraftDataFromReview, appValue, authHeader, draftData, history, onCallback, reviewData?.jobNumber]);

    const getFormatAmt = (value) => {
        // value=value.toFixed(2)
        var val = Math.round(Number(value) * 100) / 100;

        var parts = val.toFixed(2).split(".");

        var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");

        return num
    }

    const getTotalAmount = useCallback(() => {
        const totalAuditedAmount = parseInt(reviewData?.ca7Premium?.costsSum) || 0

         // eslint-disable-next-line array-callback-return
        //  reviewData?.ca7Premium?.ca7PremiumCostDTO?.map((loopItm)=>{
        //     totalAuditedAmount += loopItm.premiumAudited.amount
        // })


        if(totalAuditedAmount!==undefined)
        {
            const amount = totalAuditedAmount.toFixed(
                2
            );

            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})

            return <span className={styles.textAlignment}>Total Premium: ${getFormatAmt(amount)}</span>;
        }
        
        return ' '
        
        
    }, [reviewData?.ca7Premium?.ca7PremiumCostDTO, totalsArray]);

    const rederPrmiumAmountFormat = useCallback((amountValue) => {
        

        if(amountValue!==undefined)
        {
            const amount = amountValue.toFixed(
                2
            );

            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})

            return `$${  getFormatAmt(amount)}`;
        }
        
        return ' '
        
        
    }, [totalsArray]);

    const renderSublines = useCallback(() => {
        
        return reviewData?.ca7Premium?.ca7PremiumCostDTO?.map((subLoopItem)=>{
        return <div className={styles.bodyContentClass}>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.description}</div>
                             {/* <div className={styles.bodyContentClassStyle}>{moment(subLoopItem.effDate).format('MM/DD/YYYY')}</div> */}
                             {/* <div className={styles.bodyContentClassStyle}>{moment(subLoopItem.expirationDate).format('MM/DD/YYYY')}</div> */}
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.basisAudited}</div>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.actualAdjRate}</div>
                             <div className={styles.bodyContentClassStyleAmount}>{ rederPrmiumAmountFormat(subLoopItem.premiumAudited.amount)}</div>
                         </div>
                         

         })

        
     },[])
    
    const generateTable = useCallback(() => {
         
        return (
            <div>

 <>
    
    <div className={styles.mainHeaderClass}>
    <div className={styles.headerStyleClass}>Coverage</div>
        {/* <div className={styles.headerStyleClass}>Effective</div>
        <div className={styles.headerStyleClass}>Expiry</div> */}
        <div className={styles.headerStyleClass}>Basis</div>
        <div className={styles.headerStyleClass}>Rate</div>
        <div className={styles.headerStyleClassPremium}>Amount</div>
    </div><div>{renderSublines()}</div></>
            </div>
        )

        
    }, [renderSublines, reviewData])

    const getTotalAmountTop = useCallback(() => {

        let totalAuditedAmount = 0

        // eslint-disable-next-line array-callback-return
        reviewData?.ca7Premium?.ca7PremiumCostDTO?.map((loopItm)=>{
            totalAuditedAmount += loopItm.premiumAudited.amount
        })

        return `$${ getFormatAmt(totalAuditedAmount)}`    
    }, [reviewData]);


    const getPolicyPeriod = useCallback(() => {

        
        const startperiod = moment(reviewData?.reportPeriodStart).format(
            "MM/DD/YYYY"
        );
        const endDate = moment(reviewData?.reportPeriodEnd).format("MM/DD/YYYY");
        if(reviewData?.hasOwnProperty('paymentFrequency')){
            const paymentFrequency= reviewData?.paymentFrequency;
            return `Payroll Period : ${startperiod} - ${endDate} - (${paymentFrequency})`;
        }

        return `Payroll Period : ${startperiod} - ${endDate} `;
       
    }, [reviewData]);

    const generateOverrides = useMemo(() => {
       
        let overrides={}

        if(appValue==="CE")
        {
            overrides = individualData?.map((item, index) => {
                return {
                    [`invoiceTable${index}`]: {
                        data: individualData[index],
                    },
                  
                    
                };
            });
        }
        else{
            overrides = individualData?.map((item, index) => {
                return {
                    [`invoiceTable${index}`]: {
                        data: individualData[index],
                    },
                  
                    
                };
            });  
        }

        return Object.assign({}, ...overrides);
    }, []);

    
    

    

    
    

    const override = {
        
        ...generateOverrides,
        
        policyNumberId: {

            content: `Policy : ${reviewData?.policyNumber}`,
        },
        policyperiodId: {
            content: getPolicyPeriod(),
        },
        totalcostdataId: {
            // value: `$${reviewData.policyPremium.totalPremiumOfReport.amount.toFixed(2)}`
            content: getTotalAmount(),
        },
        totalcostdataIdTop:{
            content: getTotalAmountTop(),
        },
        // reviewDataTable:{
        //     data:reviewData?.gl7PolicyPremiums[0]?.gl7Costs
        // },
        tableDiv:{
            content:generateTable()
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        
        resolveCallbackMap: { 
            handleMakeChanges,
            handleSubmit,
        },
        resolveComponentMap:{
            // PayrollInvoiceTable:PayrollInvoiceTable
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }


    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={override}
            {...resolvers}
        />
    );
}
PayrollReviewCA.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }),
    }).isRequired,
};

export default withRouter(withViewModelService(PayrollReviewCA));
